module.exports = __webpack_public_path__ + "static/media/trash.11a22ed4.svg";